import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AgentConfigManager from '../../AgentConfigManager';

const API_URL = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000';

interface AgentStatus {
  agent_key: string;
  label: string;
  required_modul: string | null;
  aktiv: boolean;
  inaktiv_grund: string | null;
}

interface Props {
  authToken: string;
}

const AgentsSection: React.FC<Props> = ({ authToken }) => {
  const [agents, setAgents] = useState<AgentStatus[]>([]);
  const [loading, setLoading] = useState(true);
  const [fehler, setFehler] = useState<string | null>(null);

  useEffect(() => {
    axios.get<AgentStatus[]>(`${API_URL}/api/mandant/agents`, {
      headers: { Authorization: `Bearer ${authToken}` },
    })
      .then(r => setAgents(r.data))
      .catch(() => setFehler('Agent-Status konnte nicht geladen werden.'))
      .finally(() => setLoading(false));
  }, [authToken]);

  return (
    <div>
      <h3 style={{ marginTop: 0 }}>Verfügbarkeit</h3>
      <p style={{ color: 'var(--ink-2)', marginBottom: 16, fontSize: 14 }}>
        Agents sind an Module gebunden. Aktiviere das jeweilige Modul um einen Agent freizuschalten.
      </p>
      {loading && <div>Lade Agent-Status…</div>}
      {fehler && <div style={{ color: 'var(--red)' }}>{fehler}</div>}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {!loading && !fehler && agents.map(a => (
          <div key={a.agent_key} style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '10px 14px',
            border: '1px solid var(--bone-3)',
            borderRadius: 0,
            background: a.aktiv ? 'var(--bone)' : 'var(--bone)',
            opacity: a.aktiv ? 1 : 0.6,
          }}>
            <div>
              <div style={{ fontWeight: 500, fontSize: 14 }}>
                {a.aktiv ? '✓' : '✕'} {a.label}
              </div>
              {a.required_modul && (
                <div style={{ fontSize: 12, color: 'var(--ink-2)', marginTop: 2 }}>
                  Modul: <code>{a.required_modul}</code>
                  {!a.aktiv && a.inaktiv_grund && (
                    <span style={{ color: 'var(--red)', marginLeft: 8 }}>— {a.inaktiv_grund}</span>
                  )}
                </div>
              )}
              {!a.required_modul && (
                <div style={{ fontSize: 12, color: 'var(--ink-2)', marginTop: 2 }}>Immer verfügbar</div>
              )}
            </div>
          </div>
        ))}
      </div>

      <hr style={{ border: 'none', borderTop: '1px solid var(--rule)', margin: '28px 0 4px' }} />

      <AgentConfigManager authToken={authToken} />
    </div>
  );
};

export default AgentsSection;
